import React, { useState, useEffect } from "react";

import { ConfirmationModal } from "components";

import { func_validation } from "functions";


export function useConfirmation(props) {

    const [isModalVisible, setIsModalVisible] = useState(false);

    let modalDisplay = (
        <ConfirmationModal
            description={"Proceed to save changes?"}
            cancelButtonText={"Cancel"}
            confirmButtonText={"Confirm"}
            isModalVisible={isModalVisible}
            updateParentState={setIsModalVisible}
            handleOnConfirm={props.handleOnSave}
            isConfirmSuccessful={props.isPlanUpdatedSuccessfully}
            isActionLoading={props.updatePlan_requesting}
            confirmButtonProps={{
                isDisabled: props.updatePlan_requesting
            }}
        />
    );

    return {
        modalDisplay,
        setIsModalVisible
    }
}